import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirmation-page-fail',
  templateUrl: './confirmation-page-fail.component.html',
  styleUrls: ['./confirmation-page-fail.component.scss']
})
export class ConfirmationPageFailComponent {

  @Input('action') action: string;
  @Input('description') description: string;

  @Input('button1Text') button1Text: string;
  @Input('button2Text') button2Text: string;

  @Output('button1click') button1click: EventEmitter<any> = new EventEmitter();
  @Output('button2click') button2click: EventEmitter<any> = new EventEmitter();

  constructor() { }

  onButton1Click() {
    this.button1click.emit(null);
  }

  onButton2Click() {
    this.button2click.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/confirmation-page-fail/confirmation-page-fail.component.ts